import { render, staticRenderFns } from "./AmazeDashboardTile.vue?vue&type=template&id=c35fef0c&scoped=true"
import script from "./AmazeDashboardTile.vue?vue&type=script&lang=js"
export * from "./AmazeDashboardTile.vue?vue&type=script&lang=js"
import style0 from "./AmazeDashboardTile.vue?vue&type=style&index=0&id=c35fef0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35fef0c",
  null
  
)

export default component.exports